module.exports = __webpack_public_path__ + "static/media/widget.2e7733cd.svg";